import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@fontsource-variable/manrope/wght.css'
import '@fontsource-variable/fraunces/opsz.css'
import '@fontsource-variable/jetbrains-mono/wght.css'
import './styles/base.css'
import { App } from './app/App'
import { applyTheme, themeStore } from './app/theme'

applyTheme(themeStore.get())

const container = document.getElementById('root')
if (container) {
  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}
